export default __webpack_public_path__ + "static/media/030_corner1.last.fb1e4e87.png";